export default "__VITE_ASSET__BhekzbfI__"